import { DocumentFilters, ExportFormat, ExportMode, SortKey, SortState, WatchLevel } from './types';

export const STATUS_COLORS: Record<number, string> = {
  1: '#3b82f6',   // Новый
  2: '#6366f1',   // Передан
  3: '#10b981',   // Принят
  4: '#10b981',   // Принят частично
  5: '#ef4444',   // Отклонен
  6: '#64748b',   // В пути
  7: '#3b82f6',   // В обработке
  9: '#f59e0b',   // Черновик
  10: '#10b981',  // Принят с расхождениями
  11: '#ef4444',  // Ошибка остатка
  12: '#f59e0b',  // Сканирование коробов
  13: '#f59e0b',  // Подтвердить отправку
  14: '#ef4444',  // Ошибка 1С
  15: '#22c55e',  // Ожидает подтверждения
  16: '#64748b'   // Завершен
};
export const statusColor = (status: number): string => STATUS_COLORS[status] || '#94a3b8';

export const WATCH_COLORS: Record<WatchLevel, string> = { ok: '#94a3b8', warn: '#d97706', critical: '#dc2626' };

export const TYPE_OPTIONS: Array<{ value: DocumentFilters['type']; label: string }> = [
  { value: '', label: 'Все' },
  { value: '5', label: 'Перемещения' },
  { value: '4', label: 'Возвраты' }
];

export const GROUP_COLORS: Record<string, string> = {
  active: '#3b82f6',
  done: '#10b981',
  error: '#ef4444',
  draft: '#f59e0b'
};

export const EMPTY_FILTERS: DocumentFilters = {
  search: '',
  type: '',
  statuses: [],
  pharmacy: [],
  sender: [],
  recipient: [],
  region: [],
  route: '',
  marking: '',
  createdFrom: '',
  createdTo: '',
  updatedFrom: '',
  updatedTo: '',
  stuckDays: '',
  warn: false,
  hidden: 'all',
  author: '',
  product: '',
  products: []
};

export const DEFAULT_SORT: SortState = { sortBy: 'id', sortOrder: 'desc' };
export const PAGE_SIZES = [25, 50, 100, 200];

/** Названия колонок сортировки - для подписи порядка строк в окне выгрузки */
export const SORT_LABELS: Record<SortKey, string> = {
  id: '№', created: 'Создан', updated: 'Обновлён', type: 'Тип', status: 'Статус', from: 'Отправитель', to: 'Получатель', author: 'Автор'
};

export const EXPORT_FORMATS: Array<{ value: ExportFormat; label: string }> = [
  { value: 'xlsx', label: 'Excel (XLSX)' },
  { value: 'csv', label: 'CSV' }
];

export const EXPORT_MODES: Array<{ value: ExportMode; label: string; hint: string }> = [
  { value: 'documents', label: 'Документы', hint: 'Строка на документ: маршрут, статус, позиции и количество, срок автоочистки.' },
  { value: 'items', label: 'Позиции документов', hint: 'Строка на товарную позицию: товар, количество, принято, а также серии и цены, если они вам доступны.' }
];

/** Ключи localStorage - только пользовательские удобства (вид, сохранённые фильтры) */
export const VIEW_STORAGE_KEY = 'documents.v2.view';
export const SAVED_VIEWS_KEY = 'documents.v2.savedViews';

/**
 * Подсказки для кнопок, которые оператору ДОСТУПНЫ по праву, но неактивны для конкретного документа.
 * Элементы, на которые у оператора нет права, не рендерятся вовсе - подсказок «нет права» нет.
 */
export const PERM_HINTS = {
  retryOutOfZone: 'Документ вне вашей зоны повторной обработки или предыдущий статус не допускает повторную отправку',
  hideOutOfZone: 'Документ вне вашей зоны скрытия / возврата документов',
  rejectOutOfZone: 'Документ вне вашей зоны отклонения документов',
  deleteDraftOutOfZone: 'Документ вне вашей зоны удаления черновиков',
  export1cOutOfZone: 'Документ вне вашей зоны выгрузки в 1С или в нём нет идентификаторов 1С',
  extendOutOfZone: 'Документ вне вашей зоны «Проблемные документы на контроле» или не подлежит продлению'
};
